<div class="drops-tab">
  @if (loading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (loadFailed()) {
    <p class="regular-14 color-red">{{ 'cardsAdminDropLoadFailed' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-24">
      <section>
        <h2 class="semibold-18">{{ 'cardsAdminDropChances' | transloco }}</h2>
        <div class="display-flex vertical gap-12 margin-top-12">
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropQuestChance' | transloco }}</span>
            <input type="number" class="text-input" min="0" max="1" step="0.01" [formControl]="questChanceControl" />
          </label>
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropDailyQuestChance' | transloco }}</span>
            <input type="number" class="text-input" min="0" max="1" step="0.01" [formControl]="dailyQuestChanceControl" />
          </label>
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropPlaceChance' | transloco }}</span>
            <input type="number" class="text-input" min="0" max="1" step="0.01" [formControl]="placeChanceControl" />
          </label>
        </div>
      </section>

      <section>
        <h2 class="semibold-18">{{ 'cardsAdminDropWeights' | transloco }}</h2>
        <div class="display-flex vertical gap-12 margin-top-12">
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropWeightCommon' | transloco }}</span>
            <input type="number" class="text-input" min="0" step="1" [formControl]="weightCommonControl" />
          </label>
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropWeightRare' | transloco }}</span>
            <input type="number" class="text-input" min="0" step="1" [formControl]="weightRareControl" />
          </label>
          <label class="field-row display-flex gap-12">
            <span class="regular-14 field-label">{{ 'cardsAdminDropWeightLegendary' | transloco }}</span>
            <input type="number" class="text-input" min="0" step="1" [formControl]="weightLegendaryControl" />
          </label>
        </div>
      </section>

      <section>
        <h2 class="semibold-18">{{ 'cardsAdminDropOverrides' | transloco }}</h2>
        <p class="warning regular-14 margin-top-12">{{ 'cardsAdminDropWarning' | transloco }}</p>
        <div class="display-flex vertical gap-12 margin-top-12">
          <label class="checkbox-row display-flex gap-12">
            <input type="checkbox" [formControl]="ignoreWeeklyCooldownControl" />
            <span class="regular-14">{{ 'cardsAdminDropIgnoreCooldown' | transloco }}</span>
          </label>
          <label class="checkbox-row display-flex gap-12">
            <input type="checkbox" [formControl]="ignoreDailyCapControl" />
            <span class="regular-14">{{ 'cardsAdminDropIgnoreCap' | transloco }}</span>
          </label>
        </div>
      </section>

      <div class="display-flex gap-12 save-row">
        <button type="button" class="primary-btn" [disabled]="saving()" (click)="save()">{{ 'cardsAdminDropSave' | transloco }}</button>
        @if (saved()) {
          <span class="regular-14 color-green">{{ 'cardsAdminDropSaved' | transloco }}</span>
        }
        @if (error(); as err) {
          <span class="regular-14 color-red">{{ err | transloco }}</span>
        }
      </div>
    </div>
  }
</div>
